import React from 'react';
import { Button, Checkbox, Grid, Header, Label, Modal, Select, Pagination } from 'semantic-ui-react';
import { getColour } from '../../helpers/colours';
import DataGrid from '../shared/DataGrid';
import LiveFloorViewApi from '../../api/livefloorview';
import { showLiveFloorViewDetailsModal, hideLiveFloorViewDetailsModal } from '../../redux/actions/modals';
import { connect } from 'react-redux';

class LiveFloorViewDetailsModal extends React.Component {
  
  initialState = {
    eventsLoading: false,
    sessionsLoading: false,
    selectedSessionLoading: false,
    showEvents: false,
    events: {
      pageNumber: 1,
      pageCount: 1,
      grid: {
        headerDef: [],
        rowDef: [],
        data: []
      }
    },
    sessions: {
      grid: {
        headerDef: [],
        rowDef: [],
        data: []
      }
    },
    selectedSession: {
      summarysGrid: {
        headerDef: [],
        rowDef: [],
        data: []
      },
      eventsGrid: {
        headerDef: [],
        rowDef: [],
        data: []
      }
    },
    selectedPeriod: 1,
  }

  componentDidMount() {
    this.getPeriods();
  }

  getPeriods = () => LiveFloorViewApi.getPeriods().then(periods => this.setState({ periods }));

  state = {...this.initialState, periods: []};
  
  resetState = (callback) => this.setState({...this.initialState}, callback)

  getEvents = () => {
    this.setState({ eventsLoading: true }, () => {
      LiveFloorViewApi.getEvents(
        this.props.data.installation.installationId,
        this.state.selectedPeriod, 
        this.state.showEvents,
        this.state.events.pageNumber
      ).then(
        events => this.setState({ events, eventsLoading: false }),
        () => this.setState({ events: [], eventsLoading: false })
      )
    })
  }

  getSessions = () => {
    this.setState({ sessionsLoading: true }, () => {
      LiveFloorViewApi.getSessions(this.props.data.installation.installationId, this.state.selectedPeriod, this.state.showEvents)
      .then(
        sessions => this.setState({ sessions, sessionsLoading: false}),
        () => this.setState({ sessions: [], sessionsLoading: false })
      )
    })
  }

  handleRefresh = () => {
    this.setState({ selectedSession: {...this.initialState.selectedSession} }, () => {
      this.getSessions();
      this.getEvents();
    })
  }

  handlePeriodChange = (event, { value }) => this.setState({ selectedPeriod: value })

  componentDidUpdate = (prevProps, prevState) => {
    if (!prevProps.data.open && this.props.data.open) {
      this.resetState(() => this.handleRefresh())
    }
  }

  handleSessionSelect = session => {
    this.setState( { selectedSessionLoading: true }, () => {
      LiveFloorViewApi.getSession(session.sessionId)
      .then(
        selectedSession => this.setState({ selectedSession, selectedSessionLoading: false }),
        () => this.setState( { selectedSessionLoading: false })
      )
    })
  }

  render() {
    const { pageCount, pageNumber } = this.state.events;
    const stateColour = getColour(this.props.data.installation, "commsStateColour", "#CCC");
    return (
      <Modal
        open={this.props.data.open}
        onClose={() => this.props.hideLiveFloorViewDetailsModal()}
        size='fullscreen'
        closeIcon
        className="gs-flex-container-vertical h-80"
      >
        <Header>
          <Grid padded="horizontally" columns="equal">
            <Grid.Row>
              <Grid.Column>
                Live Floor View - Details
              </Grid.Column>
              <Grid.Column>
               {this.props.data.installation.siteName}
              </Grid.Column>
              <Grid.Column>
                {this.props.data.installation.gameName}, {this.props.data.installation.manufacturer}
              </Grid.Column>
              <Grid.Column>
                  EGM Asset No: {this.props.data.installation.assetNo}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Header>
        <Modal.Content className="height-100 gs-flex-container-vertical">
          <Grid columns={2} className="height-100 gs-flex-container-vertical" padded={false}>
            <Grid.Row>
              <Grid.Column width="12">
                <Select options={this.state.periods} value={this.state.selectedPeriod} onChange={this.handlePeriodChange} className="mr-1" />
                <Checkbox checked={this.state.showEvents} onClick={() => this.setState({ showEvents: !this.state.showEvents })} label="Show Events" />
                <Button size='small' onClick={this.handleRefresh} disabled={this.state.eventsLoading || this.state.sessionsLoading} positive className="ml-1">Refresh</Button>
              </Grid.Column>
              <Grid.Column width="4" textAlign="right">
                Current Status: <Label style={{ backgroundColor: stateColour, color: "#FFF", marginLeft: "4px" }}>{this.props.data.installation.commsStateText}</Label>
              </Grid.Column>
            </Grid.Row>
            <Grid.Row className="flex-stretch">
              <Grid.Column width="6" className="gs-flex-container-vertical">
                <DataGrid
                  loading={this.state.eventsLoading}
                  fullHeight
                  headings={this.state.events.grid.headerDef}
                  rowDef={this.state.events.grid.rowDef}
                  data={this.state.events.grid.data}
                  onRowClick={() => { }}
                />
                <div className="flex-shrink mt-1">
                  <Pagination totalPages={pageCount} activePage={pageNumber} onPageChange={(event, { activePage }) => this.setState({ events: {...this.state.events, pageNumber: activePage } }, () => this.getEvents()) } />
                </div>
              </Grid.Column>
              <Grid.Column width="10" className="gs-flex-container-vertical">
                <Grid padded="horizontally" className="height-100 gs-flex-container-vertical">
                  <Grid.Row>
                    <Grid.Column width={16}>
                      <DataGrid
                        loading={this.state.sessionsLoading}
                        fullHeight
                        headings={this.state.sessions.grid.headerDef}
                        rowDef={this.state.sessions.grid.rowDef}
                        data={this.state.sessions.grid.data}
                        onRowClick={this.handleSessionSelect}

                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row className="flex-stretch">
                    <Grid.Column width={4} className="gs-flex-container-vertical">
                      <DataGrid
                        loading={this.state.selectedSessionLoading}
                        fullHeight
                        headings={this.state.selectedSession.summarysGrid.headerDef}
                        rowDef={this.state.selectedSession.summarysGrid.rowDef}
                        data={this.state.selectedSession.summarysGrid.data}
                        onRowClick={() => { }}
                      />
                    </Grid.Column>
                    <Grid.Column width={12}  className="gs-flex-container-vertical">
                      <DataGrid
                        loading={this.state.selectedSessionLoading}
                        fullHeight
                        headings={this.state.selectedSession.eventsGrid.headerDef}
                        rowDef={this.state.selectedSession.eventsGrid.rowDef}
                        data={this.state.selectedSession.eventsGrid.data}
                        onRowClick={() => { }}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Modal.Content>
      </Modal>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
	return {
    data: state.liveFloorViewDetailsModal
  };
};

export default connect(mapStateToProps, { showLiveFloorViewDetailsModal, hideLiveFloorViewDetailsModal })(LiveFloorViewDetailsModal);

